const regex = /(https?:\/\/[^\s]+)/g;

export const urlifyMessage = (text: string): string =>
  text.replace(
    regex,
    url =>
      `<a href="${url}" target="_blank" style="color: deepskyblue">${url}</a>`
  );
